export default {
  lists: [],
  list: {},
  items: [],
  itemsPagination: {}
}
